<template>
  <header id="masthead">
    <div class="container h-100">
      <div class="row h-100">
        <a
          :class="{
            'nav-logo': true,
            current: isIndex
          }"
          href="/sizer"
        >
          <object
            type="image/svg+xml"
            data="/static/build/gfx/svg/logo-ecosizer.svg"
            class="logo">
          </object>
        </a>

        <nav class="primary-nav">
          <ul>
            <li>
              <a
                :class="{ current: isIndex }"
                href="/sizer/"
              >
                <span>Size Your System</span>
              </a>
            </li>

            <li>
              <a
              :class="{ current: pathname === '/sizer-utility-calc/'}"
              href="/sizer-utility-calc/"
              >
                  <span>Utility Costs</span>
                </a>
            </li>

            <li>
              <a
                :class="{ current: pathname === '/sizer/glossary_list/'}"
                href="/sizer/glossary_list"
              >
                <span>Glossary</span>
              </a>
            </li>

            <li>
              <a
                :class="{ current: pathname === '/sizer/docs/'}"
                href="/sizer/docs"
              >
                <span>Documentation</span>
              </a>
            </li>

            <li>
              <a
                :class="{ current: pathname === '/sizer/faq/'}"
                href="/sizer/faq"
              >
                <span>FAQ</span>
              </a>
            </li>

            <li>
              <a
                :class="{ current: pathname === '/sizer/about/'}"
                href="/sizer/about"
              >
                <span>About</span>
              </a>
            </li>
          </ul>
        </nav>

        <a
          v-if="pathname.includes('custom_load')"
          class="logo-mitsubishi"
          href="https://metahvac.com/"
          target="_blank"
          title="View Mitsubishi"
        >
          <img src="/static/build/gfx/svg/logo-mitsubishi.svg" class="logo" alt="Mitsubishi logo">
        </a>

        <a class="logo-ecotope" href="http://ecotope.com/" target="_blank" title="View Ecotope, Inc">
          <img src="/static/build/gfx/svg/logo-ecotope.svg" class="logo" alt="Ecotope logo">
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {},
  data: () => ({
    pathname: window.location.pathname,
    isIndex: ['/sizer/', '/sizer/size/'].includes(window.location.pathname)
  }),
}
</script>
